"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firestoreBatchChunk = void 0;
exports.groupBy = groupBy;
exports.groupByKey = groupByKey;
exports.groupByLocalDate = groupByLocalDate;
exports.groupByOrderedLocalDate = groupByOrderedLocalDate;
exports.separate = separate;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const date_1 = require("./date");
function groupBy(list, groupFn) {
    return (0, lodash_1.groupBy)(list, groupFn);
}
/**
 *
 * @param list
 * @param key must be a string
 * @returns
 */
function groupByKey(list, key) {
    const getProp = (obj) => obj[key];
    return groupBy(list, getProp);
}
/**
 * Given a date key, groups the objects by the day corresponding to that date.
 * The grouping is done relative to the local time of the machine running this method
 * e.g. 2022-01-31T07:01:01.001 is grouped under 2022-01-31
 * @param list
 * @param dateKey A key which must contain a JS date
 * @param options format alters the format of the group key. Defaults to 'yyyy-MM-dd'. Pattern reference: https://date-fns.org/v2.28.0/docs/format
 * @returns An object indexed by the date containing arrays of T
 */
function groupByLocalDate(list, dateKey, options) {
    const defaultOptions = { format: 'yyyy-MM-dd' };
    const optionsToUse = { ...defaultOptions, ...options };
    const getDate = (obj) => (0, date_1.formatDate)(obj[dateKey], optionsToUse.format);
    return groupBy(list, getDate);
}
/**
 * Given a date key, groups the objects by the day corresponding to that date.
 * The grouping is done relative to the local time of the machine running this method
 * e.g. 2022-01-31T07:01:01.001 is grouped under 2022-01-31
 * @param list
 * @param dateKey A key which must contain a JS date
 * @param options format alters the format of the group key. Defaults to 'yyyy-MM-dd'. Pattern reference: https://date-fns.org/v2.28.0/docs/format
 * @returns An array of tuples, containing the date and the grouped array. Array will be ordered by the date in ascending order
 */
function groupByOrderedLocalDate(list, dateKey, options) {
    const optionsWithDefaults = { format: 'yyyy-MM-dd', ...options };
    const groupedObj = groupByLocalDate(list, dateKey, optionsWithDefaults);
    const entries = Object.entries(groupedObj);
    const parseDateStr = (dateStr) => (0, date_fns_1.parse)(dateStr, optionsWithDefaults.format, new Date());
    const sortedEntries = (0, lodash_1.sortBy)(entries, entry => parseDateStr(entry[0]));
    return sortedEntries;
}
const firestoreBatchChunk = (arr) => (0, lodash_1.chunk)(arr, 500); // 500 is the firestore batch size
exports.firestoreBatchChunk = firestoreBatchChunk;
//  Making an exception for leaving commented code because it was hard to get the types right and would be annoying to sift through commit history
// export function groupByKey<T, K extends keyof T>(list: T[], key: T[K] extends string ? K : never) {
//   return list.reduce(
//     (prv: Record<string, T[]>, nxt: T) => ({
//       ...prv,
//       [(nxt[key] as unknown) as string]: (prv[(nxt[key] as unknown) as string] || []).concat(nxt),
//     }),
//     {}
//   )
// }
function separate(array, matchFn) {
    return array.reduce((previous, current) => {
        const [match, notMatch] = previous;
        if (matchFn(current)) {
            match.push(current);
        }
        else {
            notMatch.push(current);
        }
        return [match, notMatch];
    }, [[], []]);
}
